"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bonusOnExpressToPercent = exports.getBetPreview = exports.getBetAmountFormatted = exports.countPossibleWinSum = exports.getEnrichBetsHistoryBasketWithPlayerNames = exports.getEnrichBetsHistoryOutcomesWithPlayerNames = exports.getValuesBets = exports.getPossibleWinSum = exports.EBetStatusText = void 0;
exports.getBetEventHomeAwayCompetitors = getBetEventHomeAwayCompetitors;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const _reduxjs_1 = require("../@reduxjs");
const format_1 = require("../format");
const history_1 = require("../history");
const types_1 = require("./types");
exports.EBetStatusText = {
    [betweb_openapi_axios_1.BetStatus.Current]: 'possibility gain',
    [betweb_openapi_axios_1.BetStatus.Returned]: 'returned',
    [betweb_openapi_axios_1.BetStatus.Won]: 'won status',
    [betweb_openapi_axios_1.BetStatus.Lost]: 'lost status',
    [betweb_openapi_axios_1.BetStatus.Canceled]: 'returned',
    [betweb_openapi_axios_1.BetStatus.Sold]: 'sold',
};
const getPossibleWinSum = ({ coefficient, bet }) => coefficient ? (bet * coefficient).toFixed(0) : 0;
exports.getPossibleWinSum = getPossibleWinSum;
const getValuesBets = (betsIds, bets, players) => {
    return (0, _reduxjs_1.getValues)(betsIds, bets).map((betData) => ({
        ...betData,
        bet: (0, format_1.adjustAmountForFrontend)(betData.bet),
        amount: (0, format_1.adjustAmountForFrontend)(betData.amount),
        outcomeBonusIcon: '',
        resultText: betData === null || betData === void 0 ? void 0 : betData.status,
        eventAdditional: {},
        iconWrap: '',
        coefficient: betData.betType === betweb_openapi_axios_1.BetType.System ? 0 : betData.coefficient,
        outcomes: (0, exports.getEnrichBetsHistoryOutcomesWithPlayerNames)(betData.outcomes, players),
    }));
};
exports.getValuesBets = getValuesBets;
const getEnrichBetsHistoryOutcomesWithPlayerNames = (outcomes, players) => {
    return outcomes.map((outcome) => {
        const parameters = outcome.parameters.map((param) => {
            if (param.type === betweb_openapi_axios_1.ParameterType.PlayerId) {
                const player = players && players[param.value];
                if (player) {
                    return { ...param, playerName: player.name };
                }
            }
            return param;
        });
        return { ...outcome, parameters };
    });
};
exports.getEnrichBetsHistoryOutcomesWithPlayerNames = getEnrichBetsHistoryOutcomesWithPlayerNames;
const getEnrichBetsHistoryBasketWithPlayerNames = (bets, players) => {
    return bets.map((bet) => {
        const outcomes = (0, exports.getEnrichBetsHistoryOutcomesWithPlayerNames)(bet.outcomes, players);
        return { ...bet, outcomes };
    });
};
exports.getEnrichBetsHistoryBasketWithPlayerNames = getEnrichBetsHistoryBasketWithPlayerNames;
function getBetEventHomeAwayCompetitors(event) {
    return {
        homeCompetitors: event.competitors.filter((competitor) => competitor.home),
        awayCompetitors: event.competitors.filter((competitor) => !competitor.home),
    };
}
const countPossibleWinSum = ({ couponLoyalty, bet, currencyIcon, loyaltyCurrencyRestriction, }) => {
    const coefficientValue = bet.coefficient;
    const isBonusWallet = bet.bonusWallet;
    const COEFFICIENTS = {
        [types_1.ECoefficientType.BONUS_WALLET]: isBonusWallet && coefficientValue > 0
            ? coefficientValue - 1
            : coefficientValue,
        [types_1.ECoefficientType.DEFAULT]: coefficientValue,
    };
    const resultCoefficientValue = COEFFICIENTS[isBonusWallet ? types_1.ECoefficientType.BONUS_WALLET : types_1.ECoefficientType.DEFAULT];
    const amount = (bet === null || bet === void 0 ? void 0 : bet.appliedCouponId) && couponLoyalty
        ? (0, history_1.getBonusCouponPossibleWinSum)(bet.bet, resultCoefficientValue, loyaltyCurrencyRestriction)[couponLoyalty.coupon.payout_type]
        : (0, history_1.getCommonPossibleWinSum)({
            coefficient: resultCoefficientValue,
            bet: bet.bet,
        });
    return (0, format_1.formatAmountLocaleString)({ value: amount, currency: currencyIcon });
};
exports.countPossibleWinSum = countPossibleWinSum;
const getBetAmountFormatted = ({ bet, couponLoyalty, currencyIcon, loyaltyCurrencyRestriction, }) => {
    const isHideAmountForTypes = (0, history_1.getIsHideAmountForTypes)(bet);
    if (isHideAmountForTypes[bet.betType]) {
        return null;
    }
    else {
        return [betweb_openapi_axios_1.BetStatus.Current].includes(bet.status)
            ? (0, exports.countPossibleWinSum)({
                couponLoyalty,
                bet,
                currencyIcon,
                loyaltyCurrencyRestriction,
            })
            : (0, format_1.formatAmountLocaleString)({
                value: bet.amount,
                currency: currencyIcon,
            });
    }
};
exports.getBetAmountFormatted = getBetAmountFormatted;
const getBetPreview = ({ bet, betAmountFormatted, minBetLength = 7, maxBetLength = 15, maxBetAmountFormattedLength = 13, }) => {
    const betLength = String(bet.bet).length;
    return {
        isLongSumValue: betLength < minBetLength || betLength > maxBetLength,
        isTwoLinesPreview: (!!betAmountFormatted &&
            betAmountFormatted.length > maxBetAmountFormattedLength) ||
            betLength >= minBetLength,
    };
};
exports.getBetPreview = getBetPreview;
const bonusOnExpressToPercent = (bonus) => {
    return Math.round((bonus - 1.0) * 100);
};
exports.bonusOnExpressToPercent = bonusOnExpressToPercent;
//# sourceMappingURL=index.js.map